





























import { computed, defineComponent } from '@nuxtjs/composition-api';
import { BaseButton, BaseDivider, BaseHeading, BaseImage } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import TruncatedReadMoreTextContainer from '~/components/TruncatedReadMoreTextContainer/TruncatedReadMoreTextContainer.vue';

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Author',
  components: {
    BaseImage,
    BaseHeading,
    BaseDivider,
    BaseButton,
    TruncatedReadMoreTextContainer,
  },
  props: {
    author: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    pos: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const componentClasses = computed(() => {
      const isOdd = props.pos % 2 !== 0;

      return {
        container: ['author-container', { 'author-container-reverse': isOdd }],
        author: ['author', { 'author-reverse': isOdd }],
        profile: ['author-profile', { 'author-profile-reverse': isOdd }],
        details: ['author-details', { 'author-details-reverse': isOdd }],
      };
    });

    const authorProfileImg = computed(() => {
      return getStoryblokImageURL(props.author?.avatar?.filename);
    });

    const authorProfileImgAlt = computed(() => {
      return props.author?.avatar?.alt;
    });

    const authorFirstName = computed(() => {
      const firstName = props.author.name.split(' ')[0].toUpperCase();
      return `${firstName}'${firstName.slice(-1) === 'S' ? '' : 'S'}`;
    });

    const authorLink = computed(() => {
      return `/experts/${props.meta?.slug}`;
    });

    const authorBioText = computed(() => {
      return props.author?.bio;
    });

    const authorName = computed(() => {
      return props.author?.name;
    });

    return {
      authorProfileImg,
      authorProfileImgAlt,
      authorFirstName,
      componentClasses,
      authorLink,
      authorBioText,
      authorName,
    };
  },
});
